import React from "react"
import ToolTip from "react-portal-tooltip"
import strings from "../../localization/strings"
import FontIcon from "material-ui/FontIcon"
import { green500, grey500 } from "material-ui/styles/colors"
import { IPayrollClosedData } from "../../models"
import moment from "moment"
import AppStateStore from "../../stores/AppStateStore"
interface IProps {
	keyStr: string
	payrollStatusDocId?: string
	closedData: IPayrollClosedData
}
interface IState {
	open: boolean
}

export default class PayrollByHierarchyTableClosedColumn extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			open: false
		}
	}

	render() {
		return (
			<div>
				<ToolTip active={this.state.open} position="bottom" arrow="center" parent={"#" + "close-" + this.props.keyStr}>
					<div style={{ paddingLeft: 15, paddingRight: 15, textAlign: "center" }}>
						<span style={{ fontWeight: 600 }}>{strings.Closed}</span>
						<br />
						<span>{moment(this.props.closedData.ClosedDateTime).format("hh:mma MM/DD/YYYY")}</span>
						<br />
						<span>{`${this.props.closedData.ClosedUserName}`}</span>
					</div>
				</ToolTip>
				<div style={{ marginTop: -5, fontSize: 10, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
					<FontIcon
						id={"close-" + this.props.keyStr}
						className="fa fa-check"
						style={{ fontSize: 18, color: this.props.closedData.RecalcAccrualData.length ? grey500 : green500 }}
						onClick={e => {
							e.stopPropagation()
							this.props.closedData.RecalcAccrualData.length &&
								AppStateStore.setFailedCalcAccrualDataInfoDialogContent([{
									PayrollStatusDocId: this.props.payrollStatusDocId,
									RecalcAccrualData: this.props.closedData.RecalcAccrualData
								}])
						}}
						onMouseOver={() => this.setState({ open: true })}
						onMouseOut={() => this.setState({ open: false })}
					/>
				</div>
			</div>
		)
	}
}